import { useCallback, useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { RefreshCw, Puzzle } from "lucide-react";

/** Self-hosted kaydırmalı yapboz: parçayı arka plandaki boşluğa sürükleyin. Doğru x sunucuda saklanır. */
export const SliderCaptcha = ({ onChange, resetKey }) => {
  const [c, setC] = useState(null);
  const [x, setX] = useState(0);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const trackRef = useRef(null);
  const drag = useRef(null);

  const load = useCallback(async () => {
    setLoading(true); setDone(false); setX(0); onChange?.(null);
    try { const { data } = await api.get("/auth/captcha"); setC(data); } catch { setC(null); }
    setLoading(false);
  }, [onChange]);

  useEffect(() => { load(); }, [load, resetKey]);

  const maxX = c ? c.width - c.piece_size : 0;
  const scale = () => (trackRef.current && c ? trackRef.current.clientWidth / c.width : 1);

  const move = (clientX) => {
    if (!drag.current || done) return;
    const nx = Math.max(0, Math.min(maxX, (clientX - drag.current.startX) / scale() + drag.current.startPiece));
    setX(nx);
  };
  const start = (clientX) => { if (done || !c) return; drag.current = { startX: clientX, startPiece: x }; };
  const end = () => { if (!drag.current) return; drag.current = null; if (x > 2) { setDone(true); onChange?.({ challenge_id: c.challenge_id, slider_x: Math.round(x * 10) / 10 }); } };

  useEffect(() => {
    const mm = (e) => move(e.clientX); const mu = () => end();
    const tm = (e) => move(e.touches[0].clientX); const tu = () => end();
    window.addEventListener("mousemove", mm); window.addEventListener("mouseup", mu);
    window.addEventListener("touchmove", tm); window.addEventListener("touchend", tu);
    return () => { window.removeEventListener("mousemove", mm); window.removeEventListener("mouseup", mu); window.removeEventListener("touchmove", tm); window.removeEventListener("touchend", tu); };
  });

  return (
    <div data-testid="slider-captcha" className="space-y-2">
      <div className="flex items-center justify-between text-xs text-[#94A3B8]">
        <span className="flex items-center gap-1.5"><Puzzle className="h-3.5 w-3.5 text-[#F59E0B]" /> Yapboz doğrulaması — parçayı boşluğa sürükleyin</span>
        <button type="button" data-testid="captcha-refresh" onClick={load} className="flex items-center gap-1 text-[#64748B] hover:text-[#F1F5F9]"><RefreshCw className="h-3 w-3" /> Yenile</button>
      </div>
      <div ref={trackRef} className="relative w-full rounded-md overflow-hidden border border-[#2A364F] bg-[#0B0E17] select-none" style={{ aspectRatio: c ? `${c.width}/${c.height}` : "2/1" }}>
        {c && <img src={c.background} alt="" draggable={false} className="absolute inset-0 w-full h-full" />}
        {c && (
          <img src={c.piece} alt="" draggable={false} data-testid="captcha-piece"
            className="absolute shadow-lg" style={{ left: `${(x / c.width) * 100}%`, top: `${(c.piece_y / c.height) * 100}%`, width: `${(c.piece_size / c.width) * 100}%` }} />
        )}
        {loading && <div className="absolute inset-0 flex items-center justify-center text-xs text-[#64748B]">Yükleniyor…</div>}
      </div>
      <div className="relative h-10 rounded-md bg-[#0B0E17] border border-[#2A364F] overflow-hidden">
        <div className={`absolute inset-y-0 left-0 ${done ? "bg-[#10B981]/20" : "bg-[#3B82F6]/15"}`} style={{ width: c ? `calc(${(x / c.width) * 100}% + 40px)` : 0 }} />
        <div className="absolute inset-0 flex items-center justify-center text-[11px] text-[#64748B] pointer-events-none">{done ? "Parça yerleştirildi — giriş yapabilirsiniz" : "→ Kaydırın"}</div>
        <div data-testid="captcha-handle" onMouseDown={(e) => start(e.clientX)} onTouchStart={(e) => start(e.touches[0].clientX)}
          className={`absolute top-0 h-10 w-10 rounded-md cursor-grab active:cursor-grabbing flex items-center justify-center font-bold ${done ? "bg-[#10B981] text-[#0B0E17]" : "bg-[#3B82F6] text-white"}`}
          style={{ left: c ? `calc(${(x / c.width) * 100}% )` : 0, maxWidth: "100%" }}>≡</div>
      </div>
    </div>
  );
};
